/**
 * Parcels Receipt
 */

// React
import React, { useEffect, useState } from 'react';

// Redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Store } from '../../../../redux/reducers';
import { getOrdersAction, getPostOrderWithIdAction } from '../../actions';
import ordersRepository from 'client-sdk/src/Repository/orders-repository';
import Barcode from 'react-barcode';
import jMoment from 'moment-jalaali';

// Selector
import { createStructuredSelector } from 'reselect';

//UI
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

import { WrapperReceipt } from './style';

// Helper
import { OrderTransportationType, translate } from '../../../../utils/helpers';

// Type
import { SelectorProps, Props } from './interfaces';
import {
  makeSelectLoading,
  makeSelectError,
  makeSelectOrdersList,
} from '../../selectors';

// Style
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "absolute",
      top: 0,
      left: 0,
      '& > *': {
        '@media (max-width: 768px)': {
          margin: theme.spacing(8),
        },
      },
    },
  })
);

export function Details(props: Props) {
  const classes = useStyles();
  const [request3PLLoading, setRequest3PLLoading] = useState(false as boolean);
  const [request3PLError, setRequest3PLError] = useState(false as boolean);
  const [transportationValue, setTransportationValue] = useState<
    OrderTransportationType
  >('');
  const [orderResults3PL, setOrderResults3PL] = useState<string[]>([]);
  const orderId = props.location.search.split('?id=')[1];

  useEffect(() => {
    const { id } = props.match.params;
    // props.getOrderDispatch({});
    handleGetOrders3PL(orderId);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const getOrders3PL = async (actions: any) => {
    const payload = { ...actions };
    try {
      setRequest3PLLoading(true);
      const response = await ordersRepository.getOrderTapinBarcode({
        payload,
      });
      let barcodes: string[] = []
      response.data.barcodes.forEach(element => {
        barcodes = [...barcodes, ...element.barcode]
      });
      setOrderResults3PL(barcodes);
      window.print()
    } catch (error) {
      setRequest3PLError(error);
    } finally {
      setRequest3PLLoading(false);
    }
  };
  const handleGetOrders3PL = (orderId: []) => {
    getOrders3PL({
      ids: orderId,
    });
  };

  return (
    <WrapperReceipt className={classes.root}>
      <div className='header'>
        <div className='info'>
          <p>رسید پستی</p>
          <p>تاریخ: {`${jMoment(new Date().toISOString().split('T')[0], 'YYYY-MM-DD')
            .locale('fa')
            .format('jYYYY/jMM/jDD')}`}</p>
          <p>تعداد: {orderResults3PL.length}</p>
        </div>
        <div>
          <img src="/logo-dark.svg" alt="logo" width="200px" />
        </div>
      </div>
      <div className='print-page'>
        {orderResults3PL.map(orderResults => {
          return (
            <div className='page-container'>
              <div className="page">
                <div className=" wrapper">
                  {/*Section 1 */}
                  {orderResults && <Barcode
                    fontSize={20}
                    value={orderResults}
                    height={'60px'}
                    background="White"
                  />}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </WrapperReceipt>
  );
}

const mapStateToProps = createStructuredSelector<Store, SelectorProps>({
  ordersList: makeSelectOrdersList(),
  loading: makeSelectLoading(),
  error: makeSelectError(),
});

function mapDispatchToProps(dispatch: Function) {
  return {
    getOrderDispatch: (payload: { id: number }) =>
      dispatch(getOrdersAction(payload)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withConnect)(Details);
